import { COUNTRY_SETTINGS } from '../../../providers/myria/app-variables';
import { BillPaymentDetails } from '../../myria/app/transaction';
import { WALLET_SERVICES } from '../../types/wallet';
import { LoginPasswordType } from '../register/user-register';

export class QRCodeInfo {
  public QrType: number;
  public IdType: number;
  public Mobile: number;
  public ProxyNumber: string;
  public CardNumber: string;
  public MemberNo: number;
  public MerchantCategoryCode: string;
  public TransactionCurrency: string;
  public TransactionAmount: string;
  public TipOrConvInd: string;
  public FeeAmount: number;
  public FeePercentage: number;
  public CountryCode: string;
  public Name: string;
  public City: string;
  public PostalCode: string;
  public BranchCode: string;
  public UserId?: string;
  public QrCodeProvider?: number;
  public ReferenceNo?: string;
  public TaxAmount: number;
  public TransactionBillNumber?: string;
}

export class WalletWithdrawOrPaymentInfo {
  public CustomerId: string;
  public BranchCode: string;
  public TransactionAmount: number;
  public TransactionCurrency: string;
  public TransactionPin: string;
  public Name: string;
  public BillAmount: number;
  public BillCurrency: string;
  public TransactionBillCurrencyRate: number;
  public DestinationProxyNumber: string;
  public ActionType: string;
  public TransactionNotes: string;
  public DestinationMobile: string;
  public AccountId: number;
  public TransactionReferenceNumber: string;
  public TransactionType: number;
  public DeviceId: string;
  public LoginType: LoginPasswordType;
  public TokenReference: string;
  public TransactionFee: number;
  public ExternalReferenceNumber: string;
}

export class WalletWithdrawOrPaymentInfoForRequestBody {
  public CustomerId: string;
  public BranchCode: string;
  public TransactionAmount: string;
  public TransactionCurrency: string;
  public TransactionPin: string;
  public Name: string;
  public BillAmount: string;
  public BillCurrency: string;
  public TransactionBillCurrencyRate: string;
  public DestinationProxyNumber: string;
  public ActionType: string;
  public DestinationMobile: string;
  public TransactionNotes: string;
  public TransactionReferenceNumber: string;
  public TransactionType: string;
  public DeviceId: string;
  public LoginType: LoginPasswordType;
  public TokenReference: string;
  public ExternalReferenceNumber: string;
}

export class WalletWithdrawOrPaymentResponse {
  public CardNumber: string;
  public CardOwner: number;
  public CustomerId: string;
  public MemberNo: number;
  public ProxyNumber: string;
  public TransactionAmount: number;
  public TransactionCurrency: string;
  public TransactionDateTime: string;
  public TransactionDescription: string;
  public TransactionReferenceNumber: string;
  public TransactionStatus: number;
  public UserId: string;
  public WalletAvailableBalance: number;
  public WalletCurrencyCode: string;
  public TransactionDisplayDate: string;
  public TransactionDisplayTime: string;
  public DestinationName: string;
  public TransactionType: number;
  public Address: string;
  public DestinationAddress: DestinationAddress;
  public DestinationPaymentAccountDetails?: DestinationPaymentAccountDetails;
  public OrderDetails?:OrderDetails;
  public TransactionExpiryDateUTC: string;
  public TransactionTax: number;
  public TransactionFee: number;
  public TransactionDisplayDateAndTime: string;
  public DestinationMobile: string;
  public TransactionNotes: string;
  public SourceMobile: string;
  public SourceName: string;
  public SourceCardNumber: string;
  public MerchantCategory: CategoryType;
  public TerminalLocation: string;
  public SourceWalletCardNumber: string;
  public Narration :string;
  public BillCurrency: string;
  public BillAmount : number;
  public TransactionTotalAmount : number;
  public PanEntryType: CategoryType;
  public IsDomestic : boolean;
  public BillPaymentDetails: BillPaymentDetails;
  public MerchantAccountName?: string;
  public OrderNumber?: string;
  public BeneficiaryName?: string;
  public BeneficiaryCountry?: string;
}

export class CategoryType{
  public Code : number;
  public Description : string ;
}

export class OrderDetails {
  OrderNo: string;
  CustomerCountry?: string;
  CustomerFullName?: string;
}
export class DestinationPaymentAccountDetails {
  public BankName: string;
  public FirstName: string;
  public LastName: string;
  public MiddleName: string;
  public FullName: string;
  public PaymentAccountNumber: string;
}
export class DestinationAddress {
  public AddressLine1: string;
  public AddressLine2: string;
  public AddressLine3: string;
  public City: string;
  public CountryISO3166A2: string;
  public PostalCode: string;
  public ProvinceOrState: string;
}
export class WalletResetPinHeader {
  public CustomerId: number;
  public IdNumber: string;
  public ForceCheck: true
  public NewTransactionPin: string;
  public SecurityCode: string;
  public ReferenceValue: string;
  public Code: string;
  public ValidationReference: string;
  public TransactionPin: string;
}
export class EWalletRecipient {
  public FirstNameFromDevice: string;
  public LastNameFromDevice: string;
  public FullNameFromDevice: string;
  public FirstName: string;
  public LastName: string;
  public FullName: string;
  public PhoneNumber: string;
  public Initial: string;
  public IsStyleSet: boolean;
  public Style: any;
  public IsWalletUser: boolean;
  public Status: string;
  public StatusText: string;
  public IsContactExistsInPhone: boolean;
}

export class BankAccount{
  PaymentAccountId:number;
  BankId:string;
  BankName:string;
  FirstName?:string;
  MiddleName?:string;
  LastName?:string;
  PaymentAccountCountry:string;
  Bic?:string
  PaymentAccountNumber:string;
  FullName: string;
}

export class WalletCard{
  CardExpiry: string;
  CardNumber: string;
  DisplayCardNumber: string;
  BinNumber: string;
  CardExpiryDate: number;
  CardType: number;
  CardTypeDisplayText: string;
  MemberNo: number;
  PinSetFlag: number;
  ProxyNumber: string;
  Status: number;
  CardImage?: string
  CardProvider?: string
  CardTitle?: string
  ClassName?: string
  CanShowCardType?: boolean
  IsCardLocked?: boolean
  CanShowDetails: boolean;
  IsCardLockedForSecurityReasons:boolean;
  IsExpiring: boolean;
  PinCreated: boolean;
  CVV?: number;
  CardExpiryDisplayString: string;
  DaysUntilExpiry: number
  IsCardExpired?: boolean
  CardVisableCounterInSec?: string
  CardVisableInSec?: number
}

export class WalletCardLimits{
  TransactionLimitPerDay: number;
  TransactionAmountPerDay: number;
  TransactionLimitPerMonth: number;
  TransactionAmountPerMonth: number;
  ChannelId: number;
  ControlType: number;
  LimitFrequency: number;
  TransactionType: string;
  WalletCurrencyCodePerDay:string;
  WalletCurrencyCodePerMonth:string;
}

export class RmtCardInformationGroup{
  left?: string;
  right?: string;
  icon?: string;
  seperator?: boolean;
  lastItem?: boolean;
  limitsItemHeader?: boolean;
  limitsItem?: boolean;
  rightBtnLabel?: string;
  singleLineText?: string;
  largeIcon?: boolean;
  leftLabelIcon?: string;
  rightLabelIcon?: string;
}

export class WalletWithdrawOrPaymentInfoMapper {
/**
 *
 * this mapper to convert the amounts variables and rate to  string
 * to fix issue when send in request body number with decimal point can be approximated to another value
 * this mapper used now before withdraw / pay wallet call
 */
  public static fromWalletInfoToWalletInfoForRequest(entity: WalletWithdrawOrPaymentInfo): WalletWithdrawOrPaymentInfoForRequestBody {
    let walletInfo = new WalletWithdrawOrPaymentInfoForRequestBody()

      walletInfo.CustomerId = entity.CustomerId;
      walletInfo.BranchCode = entity.BranchCode;

      if(entity.TransactionAmount)
        walletInfo.TransactionAmount = entity.TransactionAmount.toString();

      if(entity.BillAmount)
        walletInfo.BillAmount = entity.BillAmount.toString();

      if(entity.TransactionBillCurrencyRate)
        walletInfo.TransactionBillCurrencyRate = entity.TransactionBillCurrencyRate.toString();

      if(entity.TransactionType)
        walletInfo.TransactionType = entity.TransactionType.toString();

      if(entity.TransactionReferenceNumber)
        walletInfo.TransactionReferenceNumber = entity.TransactionReferenceNumber;

      if(entity.DestinationProxyNumber)
        walletInfo.DestinationProxyNumber = entity.DestinationProxyNumber;

      if(entity.DeviceId)
        walletInfo.DeviceId = entity.DeviceId;

      if(entity.TokenReference)
        walletInfo.TokenReference = entity.TokenReference;

      if(entity.LoginType)
        walletInfo.LoginType = entity.LoginType;

      walletInfo.TransactionCurrency = entity.TransactionCurrency;
      walletInfo.TransactionPin = entity.TransactionPin;
      walletInfo.Name = entity.Name;
      walletInfo.BillCurrency = entity.BillCurrency;
      walletInfo.ActionType = entity.ActionType;
      if(entity.DestinationMobile && entity.DestinationMobile.length > 0){
        if(entity.DestinationMobile.indexOf("+") !== -1){
          entity.DestinationMobile = entity.DestinationMobile.substring(1, entity.DestinationMobile.length);
        }
        walletInfo.DestinationMobile = entity.DestinationMobile;
      }
      if(entity.TransactionNotes){
        walletInfo.TransactionNotes = entity.TransactionNotes;
      }
      if(entity.ExternalReferenceNumber){
        walletInfo.ExternalReferenceNumber = entity.ExternalReferenceNumber;
      }
    return walletInfo
  }
}

export class WalletValidatePinHeader {
  public CustomerId: number;
  public ProxyNumber: string;
  public TransactionPin: string;
}

export enum WALLETCPINLOCKREASON{
    INVALIDPIN = "Invalid pin"
}

export enum WALLETCPINLOCKLOCATION{
    CARDSETTING = "Card Setting Home"
}

export enum QrIDtype {
  Customer = 0,
  Merchant = 1,
  RiaStore = 2
}

export enum QrCodeProvider {
  Ria = 1,
  DuitNow = 2
}

export enum QrScannerTab {
  Pay = 0,
  Withdraw = 1,
  MyRiaQR = 2,
}

export const WALLETPASSCODETVAL = {
  SUCCESS: 1,
}
export class WalletForgotPasscodeRes{
  IdVerificationRemainingAttempts: string;
  SendMfaRemainingAttempts: string;
  KycDone: string;
  TokenReference: string;
  MaskedIdNumber: string;
  MaskedPhone: string;
  SecurityCode: string;
  ReferenceValue: string;
  MaskedEmail: string;
  WaitingOtpTime: string;
  CodeDescription: string;
  Code: string;
  OTPRemainingAttempts: string;
}
export interface IBoldLabel {
  boldLabel: string;
  value: string;
}

export enum WALLET_RESPONSE{
  EFT_ERR_REEPONSE = 1000,
  QR_CODE_RATE_LIMITED = 8117
}

export enum WALLET_SANDBOX_BANK_STATUS{
  PASS = 'Pass',
  FAIL = 'Fail',
  SKIPPED = 'Skipped',
  PASS_FPX = 'Pass-Fpx',
  NOBANK = 'NoBank'
}

export enum WALLET_SANDBOX_SETTING{
  BANK_VALIDATION = 23010,
  CUSTOMER_VISA_CHECK = 950,
  VISA_TYPE_EXPAT = 111, // Visa1/2
  VISA_TYPE_FOREIGNER = 211, // Visa3,
  IS_SANDBOX_USER = 23020,
  VISA_UNDER_PROCESS = 23031
}

export enum DOCUMENT_TYPE{
  COPIED_PASSORT = "photoCopiedPassport",
  ORIGINAL_PASSORT = "originalPassport"
}

// Source classification for cached / prefetched / network-fresh responses used in the SN wallet
// perf instrumentation (LoggerProvider.info lines, internal counters). String values are stable —
// log greps and dashboards rely on them.
export enum PerfSource {
  Network = 'network',
  Cache = 'cache',
  Prefetch = 'prefetch'
}

export interface ITabMenuItem {
  label: string,
  subtitle?: string,
  imgUrl: string,
  greyedOut?: boolean,
  disable?: boolean,
  tooltipEnabled?: boolean,
  buttonType?: string,
  action: () => void
}

export class DisabledServiceSetting {
  type: WALLET_SERVICES;
  flag: COUNTRY_SETTINGS;
  property: string;
  messageKey: string;
  headerKey: string;
  bodyKey: string;
}

export enum HELP_OPTION {
  CALL = 'call',
  CHAT = 'chat',
  HELP_CENTER = 'helpCenter'
}


// WEBPACK FOOTER //
// ./src/model/models/wallet/wallet.ts